import * as Sentry from "@sentry/react"

// Reports rejected thunks / RTK Query calls, and anything a reducer or middleware throws.
export const sentryReduxMiddleware = store => next => action => {
    try {
        const result = next(action)

        // A "condition" rejection is RTK skipping a call (already cached / in flight), not an error
        if (action.type?.endsWith("/rejected") && !action.meta?.condition) {
            Sentry.withScope(scope => {
                scope.setTag("redux-action", action.type)
                scope.setExtra("action", action)
                // Who hit it — never the whole auth state, which carries the token
                const { userInfo } = store.getState()?.auth || {}
                scope.setContext("user", {
                    id: userInfo?.id,
                    companyId: userInfo?.companyId,
                    companyGroup: userInfo?.companyGroup,
                })
                Sentry.captureException(action.error)
            })
        }

        return result
    } catch (error) {
        Sentry.captureException(error)
        throw error
    }
}
